import { render, staticRenderFns } from "./ReleasesListAdminTable.vue?vue&type=template&id=7cfa3769&"
import script from "./ReleasesListAdminTable.vue?vue&type=script&lang=js&"
export * from "./ReleasesListAdminTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports